import { render, staticRenderFns } from "./KennelRegistrationSignatures.vue?vue&type=template&id=9708fbfe"
import script from "./KennelRegistrationSignatures.vue?vue&type=script&lang=ts"
export * from "./KennelRegistrationSignatures.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports